import { IFormFieldsProps } from './types';

export const FormFields = ({ children }: IFormFieldsProps) => <div className="flex flex-col gap-4">{children}</div>;
